// Note: This file is autogenerated using "resources/gen-version.js" script and
// automatically updated by "npm version" command.

/**
 * A string containing the version of the GraphQL.js library
 */
export const version = '16.12.0';
/**
 * An object containing the components of the GraphQL.js version string
 */

export const versionInfo = Object.freeze({
  major: 16,
  minor: 12,
  patch: 0,
  preReleaseTag: null,
});
